export default __webpack_public_path__ + "static/media/monopanti ypercheilisi2.ff98e9c1.webp";